import React, { useEffect, useState, useCallback } from 'react';
import moment from 'moment';
import { Box, Typography, Button } from '@mui/material';
import { BsPlusCircle } from 'react-icons/bs';
import { Table } from 'components';
import { getColumnsPersonal } from './columns-personal';
import ApiServices from 'services';
import Utils from 'commons/utils';
import { ContainerHeader, BtnCreateContract } from './styles';
// import storage from 'storage';
import { CreateForm } from './create-form';
import { ModalFormDetail } from 'components';
import { debounce } from 'lodash';
import { ModalConfirmDelete } from '../../modal-confirm-delete';
import { styled } from '@mui/material/styles';

const DEFAULT_FILTER = {
  pageNumber: 1,
  pageSize: 10,
};

export function QuotePriceTab({ clientCareHistoryItem, clientInformationDetail, value, setValue }) {
  const [contractList, setContractList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selected, setSelected] = useState(null);
  const [totalRecords, setTotalRecords] = useState(0);

  const [searchQuotationDate, setSearchQuotationDate] = useState(null);
  const [searchCustomerResponseDate, setSearchCustomerResponseDate] = useState(null);

  const [searchStatus, setSearchStatus] = useState(-1);

  const [filter, setFilter] = useState(DEFAULT_FILTER);

  const [selectedDelete, setSelectedDelete] = useState(null);

  const initData = (query, status = searchStatus, newClientCompanyId) => {
    setLoading(true);
    return ApiServices.getPagingClientQuotation(query ? query : filter, status, newClientCompanyId)
      .then((res) => {
        if (res?.data) {
          if (totalRecords !== res?.data?.totalRecords) setTotalRecords(res?.data?.totalRecords);
          setContractList(res?.data?.data || []);
        }
      })
      .catch((err) => console.warn('get Client Trash:', err))
      .finally(() => setLoading(false));
  };

  const handleSearchColumn = (event) => {
    setFilter((prev) => {
      const searchArray = { ...prev.searchArray };
      const { value, name } = event.target;
      if (!value) {
        delete searchArray[name];
        return { ...prev, pageNumber: 1, searchArray };
      }
      searchArray[name] = value;
      return { ...prev, pageNumber: 1, searchArray };
    });
  };
  const handleSearchColumnDate = (value, name) => {
    setFilter((prev) => {
      const searchArray = { ...prev.searchArray };

      if (!value) {
        delete searchArray[name];
        return { ...prev, pageNumber: 1, searchArray };
      }
      searchArray[name] = value;
      return { ...prev, pageNumber: 1, searchArray };
    });
  };

  const timeoutGetData = useCallback(
    debounce((newFilter, newSearchStatus, newClientCompanyId) => {
      initData(newFilter, newSearchStatus, newClientCompanyId);
    }, 500),
    [],
  );
  useEffect(() => {
    if (clientCareHistoryItem?.clientCompanyId) {
      timeoutGetData(filter, searchStatus, clientCareHistoryItem.clientCompanyId);
    }
  }, [filter, searchStatus, clientCareHistoryItem?.clientCompanyId]);

  const onCloseModal = () => {
    setSelected(null);
  };
  const onCloseModalDelete = () => {
    setSelectedDelete(null);
  };

  const reloadData = async () => {
    return await initData(filter, searchStatus, clientCareHistoryItem?.clientCompanyId);
  };

  const handleChangeSearchQuotationDate = (event) => {
    const date = event.target.value;
    setSearchQuotationDate(date);

    const dateSearch = date ? moment(date).format('YYYY-MM-DD') : null;
    handleSearchColumnDate(dateSearch, 'quotationDate');
  };

  const handleChangeSearchCustomerResponseDate = (event) => {
    const date = event.target.value;
    setSearchCustomerResponseDate(date);

    const dateSearch = date ? moment(date).format('YYYY-MM-DD') : null;
    handleSearchColumnDate(dateSearch, 'customerResponseDate');
  };

  const handleChangeSearchStatus = (event) => {
    let value = event.target.value;

    setSearchStatus(value);
  };

  const deleteItem = async (row) => {
    setLoading(true);
    try {
      const res = await ApiServices.deleteQuotePrice(row?.id);
      if (res) {
        window.UIMessage?.success('Xóa thành công');
        reloadData();
      }
    } catch (err) {
      window.UIMessage?.error('Xóa thất bại !!!');
      console.warn('delete contract', err);
    } finally {
      setLoading(false);
      onCloseModalDelete();
    }
  };

  const validateValue = (row) => {
    const dataSelect = row;
    dataSelect.quotationDate = Utils.checkIsDate(row.quotationDate)
      ? Utils.convertToDateFormat(row?.quotationDate)
      : null;
    dataSelect.customerResponseDate = Utils.checkIsDate(row.customerResponseDate)
      ? Utils.convertToDateFormat(row?.customerResponseDate)
      : null;

    return dataSelect;
  };

  const renderHeader = () => (
    <>
      <ContainerHeader>
        <Typography variant="h6" component="h6" sx={{ m: '10px' }}>
          Báo giá
        </Typography>
      </ContainerHeader>
      {/* <ButtonExport
        variant="outlined"
        startIcon={<BsArrowDownCircle />}
        onClick={handleExportClient}
      >
        Tải excel
      </ButtonExport> */}
      <BtnCreateContract
        variant="contained"
        startIcon={<BsPlusCircle />}
        onClick={() => setSelected({ isNew: true })}
      >
        Thêm mới
      </BtnCreateContract>
    </>
  );

  const handleSelected = (row) => {
    const dataSelect = validateValue(row);
    setSelected(dataSelect);
  };

  return (
    <>
      <Box sx={{ width: '100%' }}>
        <Table
          rows={contractList}
          headCells={getColumnsPersonal(
            handleSearchColumn,
            deleteItem,
            searchQuotationDate,
            handleChangeSearchQuotationDate,
            searchCustomerResponseDate,
            handleChangeSearchCustomerResponseDate,
            searchStatus,
            handleChangeSearchStatus,
            setSelectedDelete,
          )}
          totalRecords={totalRecords}
          onPageChange={(paging) => {
            setFilter((prev) => ({ ...prev, ...paging }));
          }}
          onClickDetail={handleSelected}
          loading={loading}
          renderHeader={renderHeader}
        />

        <ModalFormDetail
          open={selected}
          onCloseModal={onCloseModal}
          title={selected?.isNew ? 'Thêm mới' : 'Cập nhật'}
          maxWidth="md"
        >
          <CreateForm
            reloadData={reloadData}
            onCloseModal={onCloseModal}
            selected={selected}
            clientCareHistoryItem={clientCareHistoryItem}
          />
        </ModalFormDetail>

        <ModalFormDetail
          open={selectedDelete}
          onCloseModal={onCloseModalDelete}
          title="Bạn muốn chắc chắn xóa?"
          maxWidth="xs"
        >
          <Box sx={{ marginLeft: 'auto', display: 'flex', flexDirection: 'row' }}>
            <Box
              sx={{
                marginLeft: 'auto',
              }}
            >
              <BtnCancel onClick={onCloseModalDelete}>Hủy</BtnCancel>
              <BtnAccept onClick={() => deleteItem(selectedDelete)}>Xác nhận</BtnAccept>
            </Box>
          </Box>
        </ModalFormDetail>
      </Box>
    </>
  );
}

const BtnCancel = styled(Button)(({ theme }) => ({
  borderRadius: '20px',
  marginLeft: '8px',
  color: '#FFFFFF',
  backgroundColor: '#555',
  opacity: 0.7,
  '.MuiButton-endIcon': {
    marginLeft: '0px',
  },
  '&:hover': {
    backgroundColor: '#555',
    opacity: 0.5,
  },
  padding: '6px 16px 2px 16px',
  textTransform: 'none',
  fontWeight: 'normal',
}));

const BtnAccept = styled(Button)(({ theme }) => ({
  borderRadius: '20px',
  marginLeft: '8px',
  color: '#FFFFFF',
  backgroundColor: '#13265b',
  '.MuiButton-endIcon': {
    marginLeft: '0px',
  },
  '&:hover': {
    backgroundColor: '#13265b',
    opacity: 0.7,
  },
  padding: '6px 16px 2px 16px',
  textTransform: 'none',
  fontWeight: 'normal',
}));
